import { Button, Grid } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect } from "react";
import { useAppContext } from "../../../libs/app-core/AppContext";
import { DialogButtons } from "../../../libs/app-core/dialogs/DialogButtons";
import { MessageDialog } from "../../../libs/app-core/dialogs/MessageDialog";
import { Toast } from "../../../libs/app-core/Toast";
import { useGridApiRef } from "../../../libs/data-grid-view/useGridApiRef";
import { linear_v, linear_item, linear_h, } from "../../../libs/linear-layout/LinearLayout";
import Title from "../../../libs/rhf-mui/ui/Title";
import AppMenuButton from "../../components/AppMenuButton";
import { SpwkUtil } from "../../dao/SpwkUtil";
import { HisRuleOptions, VisibleModeOptions } from "../../dao/SpwkUtilV3";
import { UniForm } from "../../dao/UniForm";
import { UniFunc } from "../../dao/UniFunc";
import { UniQuestion, ValidWhenRule } from "../../dao/UniQuestion";
import { UniQuestionDAO } from "../../dao/UniQuestionDAO";
import { OnApiError } from "../../ErrorManager";

type Props = {
  onClickRefresh?: React.MouseEventHandler<HTMLButtonElement> | undefined;

  CurrUniFunc: UniFunc | null;
  CurrUniForm: UniForm | null;
  _UniQuestionList: UniQuestion[];
  set_UniQuestionList: (data_list: UniQuestion[]) => void;
  refreshUniQuestionList: () => Promise<void>;
  OnRowClick: (sel_data: UniQuestion) => void;

  InitFocusQuestionGuid: string | undefined;
};

const DgvUniQuestion = ({
  onClickRefresh,
  CurrUniFunc,
  CurrUniForm,
  _UniQuestionList,
  set_UniQuestionList,
  refreshUniQuestionList,
  OnRowClick,
  InitFocusQuestionGuid,
}: Props) => {
  const ctx = useAppContext();

  const uni_qustion_columns: GridColDef[] = [
    { field: "serno", headerName: "serno", width: 85, editable: true },
    { field: "sort_no", headerName: "sort_no", width: 85, editable: true },

    { field: "v3_mode", headerName: "v3_mode", width: 80, editable: true },

    { field: "chapter", headerName: "chapter", width: 180, editable: true },
    {
      field: "kind",
      headerName: "kind",
      width: 90,
      editable: true,
      type: "singleSelect",
      valueOptions: [
        { value: SpwkUtil.KIND_空白, label: "(空白)" },
        { value: SpwkUtil.KIND_單選, label: "單選" },
        { value: SpwkUtil.KIND_多選, label: "多選" },
        { value: SpwkUtil.KIND_非選, label: "非選" },
        { value: SpwkUtil.KIND_標題, label: "標題" },
        { value: SpwkUtil.KIND_圖片, label: "圖片" },
        { value: SpwkUtil.KIND_自訂, label: "自訂" },
      ],
    },

    {
      field: "variant",
      headerName: "variant",
      width: 90,
      editable: true,
      type: "singleSelect",
      valueOptions: [
        { value: "", label: "(空白)" },
        { value: "h6", label: "h6 主要章節標題" },
        { value: "subtitle2", label: "subtitle2 一般標題" },
        { value: "body2", label: "body2 題目標題" },
      ],
    },

    {
      field: "q_his_rule",
      headerName: "his_rule",
      width: 90,
      editable: true,
      type: "singleSelect",
      valueOptions: HisRuleOptions,
    },

    {
      field: "valid_when_rule",
      headerName: "valid_when_rule",
      width: 140,
      editable: true,
      type: "singleSelect",
      valueOptions: [
        { value: ValidWhenRule.None, label: "None" },
        { value: ValidWhenRule.是否曾經從事其他工作, label: "是否曾經從事其他工作" },
        { value: ValidWhenRule.B02_新進_變更, label: "B02_新進" },
        { value: ValidWhenRule.B02_定期_追蹤, label: "B02_定期" },
        { value: ValidWhenRule.B02_是否配戴護具, label: "B02_是否配戴護具" },
        { value: ValidWhenRule.B02_耳部感染或手術, label: "B02_耳部感染或手術" },
        { value: ValidWhenRule.B02_如果從事上面的任何工作, label: "B02_如果從事上面的任何工作" },
        { value: ValidWhenRule.單選_連動, label: "單選_連動" },


      ],
    },
    { field: "valid_when_rhf_name", headerName: "valid_when_rhf_name", width: 140, editable: true, },
    { field: "valid_when_rhf_value", headerName: "valid_when_rhf_value", width: 140, editable: true, },
    { field: "ch_his_code", headerName: "ch_his_code", width: 100, editable: true, },
    { field: "q_his_code", headerName: "q_his_code", width: 100, editable: true, },
    { field: "q_gov_code", headerName: "q_gov_code", width: 100, editable: true, },
    { field: "question_code", headerName: "code", width: 240, editable: true },
    { field: "question_title", headerName: "title", width: 480, editable: true, },
    { field: "question_filter", headerName: "filter", width: 240, editable: true, },
    { field: 'q_visible', headerName: 'q_visible', width: 160, editable: true, type: "singleSelect", valueOptions: VisibleModeOptions, },
    { field: "remark", headerName: "remark", width: 240, editable: true },
    {
      field: "xs_inline", headerName: "xs_inline", width: 90, editable: true, type: "singleSelect",
      valueOptions: [
        { value: "", label: "標題換行" },
        { value: "1", label: "標題維持一行" },
      ],
    },
    {
      field: "sm_inline", headerName: "sm_inline", width: 90, editable: true, type: "singleSelect",
      valueOptions: [
        { value: "", label: "標題換行" },
        { value: "1", label: "標題維持一行" },
      ],
    },
    {
      field: "xs_opt_w", headerName: "xs_opt_w", width: 90, editable: true, type: "singleSelect",
      valueOptions: [
        { value: "", label: "(空白)" },
        { value: "auto", label: "流水排列" },
        { value: "100%", label: "1欄" },
        { value: "50%", label: "2欄" },
        { value: "33%", label: "3欄" },
        { value: "25%", label: "4欄" },
        { value: "20%", label: "5欄" },
      ],
    },
    {
      field: "sm_opt_w", headerName: "sm_opt_w", width: 90, editable: true, type: "singleSelect",
      valueOptions: [
        { value: "", label: "(空白)" },
        { value: "100%", label: "1欄" },
        { value: "50%", label: "2欄" },
        { value: "33%", label: "3欄" },
        { value: "25%", label: "4欄" },
        { value: "20%", label: "5欄" },
      ],
    },
    { field: "xs_pb", headerName: "xs_pb", width: 90, editable: true },
    { field: "sm_pb", headerName: "sm_pb", width: 90, editable: true },
    { field: "title_eng", headerName: "英文", width: 500, editable: true },
    { field: "title_ind", headerName: "印尼", width: 500, editable: true },
    { field: "title_tha", headerName: "泰國", width: 500, editable: true },
    { field: "title_tgl", headerName: "菲律賓", width: 500, editable: true },
    { field: "title_vie", headerName: "越南", width: 500, editable: true },
  ];

  const grid_api_qustion = useGridApiRef(uni_qustion_columns);

  useEffect(() => {
    async function try_focus_row() {
      if (InitFocusQuestionGuid == null) {
        return;
      }

      grid_api_qustion.apiRef.current?.setSelectionModel([
        InitFocusQuestionGuid,
      ]);
    }

    try_focus_row();
  }, [InitFocusQuestionGuid]);

  return (
    <Grid {...linear_v}>
      <Grid {...linear_item}>{render_dgv問題_ActionBar()}</Grid>
      <Grid {...linear_item} flex={1}>
        {render_dgv問題_DataGrid()}
      </Grid>
    </Grid>
  );

  /** 取得當前 Row 的 Data */
  function getCurrRowData(): UniQuestion | null {
    let sel_rows = grid_api_qustion.apiRef.current?.getSelectedRows();

    if (sel_rows == null) {
      Toast.ShowWarning(ctx, "請選擇資料");
      return null;
    }

    const array = Array.from(sel_rows, ([key, value]) => value);

    if (array.length !== 1) {
      Toast.ShowWarning(ctx, "請選擇資料");
      return null;
    }

    const data = array[0] as UniQuestion;

    return data;
  }

  function btn_刪除_Click() {
    const data = getCurrRowData();
    if (data == null) {
      return;
    }

    MessageDialog.Show(
      ctx,
      data.serno + ":" + data.question_title,
      "是否刪除選定資料?",
      {
        ...DialogButtons.DeleteCancel,
        async onDialogResult(e) {
          if (e.DialogResult === "Yes") {
            try {
              await UniQuestionDAO.Delete(data);

              set_UniQuestionList([
                ..._UniQuestionList.filter((x) => x.guid !== data.guid),
              ]);

              Toast.Show(ctx, "資料已刪除");
            } catch (ex: any) {
              OnApiError(ctx, ex);
            }
          } else {
            Toast.Show(ctx, "取消");
          }
        },
      }
    );
  }

  function render_dgv問題_ActionBar() {
    return (
      <Grid {...linear_h} alignItems="center" p={1}>
        <AppMenuButton
          label={
            <Title variant="subtitle2">
              {CurrUniFunc?.getCodeTitle() + "  -  ver." + CurrUniForm?.ver}
            </Title>
          }
        />

        <Grid {...linear_item} flex={1}>
          <Button onClick={onClickRefresh}>
            重新整理
          </Button>
        </Grid>

        <Grid {...linear_item} flex={1}>
          {/* blank full width */}
        </Grid>

        <Grid {...linear_item}>
          <Button onClick={btn_上移_Click}>上移</Button>
        </Grid>

        <Grid {...linear_item}>
          <Button onClick={btn_下移_Click}>下移</Button>
        </Grid>

        <Grid {...linear_item}>
          <Button onClick={btn_確定排序_Click}>確定排序</Button>
        </Grid>

        <Grid {...linear_item}>
          <Button onClick={btn_新增問題_Click}>新增問題</Button>
        </Grid>

        <Grid {...linear_item}>
          <Button color="error" onClick={btn_刪除_Click}>
            {"刪除"}
          </Button>
        </Grid>

        <Grid {...linear_item}>
          <Title>...</Title>
        </Grid>
      </Grid>
    );
  }

  async function btn_確定排序_Click() {
    let ii = 1;
    for (let data of _UniQuestionList) {
      await UniQuestionDAO.Update_SetSortNo(data, ii);
      ii++;
    }

    set_UniQuestionList([..._UniQuestionList]);
    Toast.ShowScuccess(ctx, "已保存順序");
    // UniQuestion
  }

  function btn_上移_Click() {
    const data = getCurrRowData();
    if (data == null) {
      return;
    }

    const index = _UniQuestionList.indexOf(data);

    if (index - 1 < 0) {
      Toast.ShowWarning(ctx, "無法上移");
      return;
    }

    set_UniQuestionList(array_move([..._UniQuestionList], index, index - 1));

    Toast.Show(ctx, "上移");
  }

  // https://stackoverflow.com/questions/5306680/move-an-array-element-from-one-array-position-to-another
  function array_move(arr: any[], old_index: number, new_index: number) {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
  }

  function btn_下移_Click() {
    const data = getCurrRowData();
    if (data == null) {
      return;
    }

    const index = _UniQuestionList.indexOf(data);

    if (index + 1 >= _UniQuestionList.length) {
      Toast.ShowWarning(ctx, "無法下移");
      return;
    }

    set_UniQuestionList(array_move([..._UniQuestionList], index, index + 1));

    Toast.Show(ctx, "下移");
  }

  async function btn_新增問題_Click() {
    try {
      if (CurrUniForm == null || CurrUniForm.guid == null) {
        Toast.ShowWarning(ctx, "請先選擇問卷");
        return;
      }

      await UniQuestionDAO.Insert_新增空白題目(CurrUniForm.guid);
      await refreshUniQuestionList();

      Toast.Show(ctx, "新增問題");
    } catch (ex: any) {
      OnApiError(ctx, ex);
    }
  }

  function render_dgv問題_DataGrid() {
    return (
      <DataGrid
        style={{ width: "100%", backgroundColor: "white", padding: "12px" }}
        getRowId={(data) => {
          return data.guid;
        }}
        rows={_UniQuestionList}
        columns={grid_api_qustion.columns}
        density={"compact"}
        pageSize={100}
        rowsPerPageOptions={[100]}
        hideFooterSelectedRowCount
        hideFooter
        onRowClick={(params) => {
          const sel_data = params.row as UniQuestion;
          OnRowClick(sel_data);
        }}

        onCellEditCommit={async (params, event, details) => {
          const { id, field, value } = params;
          const find_data = new UniQuestion();
          find_data.guid = id as string;

          try {
            await UniQuestionDAO.UpdateOneField(
              find_data,
              field,
              value
            );
            refreshUniQuestionList();
            Toast.ShowScuccess(ctx, "儲存成功");
          } catch {
            Toast.ShowDanger(ctx, "儲存失敗!!!");
          }
        }}
      />
    );
  }
};

export default DgvUniQuestion;
